import DataApi from "../../../api/DataApi";
import PubSub from "pubsub-js";

/**
 * Kanban view handlers
 */
export const createKanbanHandlers = (objectName, setEditingRecordId, setIsCloneMode, setEditModalShow, setRefreshTrigger) => {
  const handleKanbanUpdateRecord = async (recordId, updates) => {
    try {
      const dataApi = new DataApi(`object/${objectName}`);
      await dataApi.update(updates, recordId);

      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Record Updated",
        message: "Record updated successfully"
      });

      setRefreshTrigger(prev => prev + 1);
    } catch (error) {
      console.error('Error updating record:', error);
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Update Error",
        message: "Error updating record: " + (error.response?.data?.message || error.message)
      });
      throw error;
    }
  };

  const handleKanbanEdit = (record) => {
    const recordIdValue = record.id?.value || record.id;
    setEditingRecordId(recordIdValue);
    setIsCloneMode(false);
    setEditModalShow(true);
  };

  const handleKanbanClone = (record) => {
    const recordIdValue = record.id?.value || record.id;
    setEditingRecordId(recordIdValue);
    setIsCloneMode(true);
    setEditModalShow(true);
  };

  const handleKanbanDelete = async (record) => {
    const recordIdValue = record.id?.value || record.id;
    const recordName = record.name?.displayValue || record.name?.value ||
      record.subject?.displayValue || record.subject?.value || 'this record';

    if (!window.confirm(`Are you sure you want to delete "${recordName}"?`)) {
      return;
    }

    try {
      const dataApi = new DataApi(`object/${objectName}`);
      await dataApi.delete(`/${recordIdValue}`);

      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Record Deleted",
        message: "Record deleted successfully"
      });

      setRefreshTrigger(prev => prev + 1);
    } catch (error) {
      console.error('Error deleting record:', error);
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Delete Error",
        message: "Error deleting record: " + (error.response?.data?.message || error.message)
      });
    }
  };

  return {
    handleKanbanUpdateRecord,
    handleKanbanEdit,
    handleKanbanClone,
    handleKanbanDelete
  };
};
